export function handleScrollView(selector) {
	if (typeof selector === 'object') {
		var $cont = selector.find('.scroll-view');
	} else {
		var $cont = $(selector + ' .scroll-view');
	}

	$cont.each(function (idx) {
		let $div = $(this);

		$div.closest('.scroll-view-container').css('height', $div.data('height') + 'px');

		window.setTimeout(function () {
			var scrollView = $div.kendoScrollView({
				enablePager: true,
				contentHeight: "100%"
			}).data("kendoScrollView");

			$div.find('[data-role="page"]').on('click', function (event) {
				let $el = $(this);
				$el.closest('.scroll-view-container').toggleClass('fullscreen');
				scrollView.refresh();
			});
		}, 200);
	});

}
